<template>
<v-container mb-5>
    <v-layout mt-5 wrap align-baseline>

        <v-flex xs12 md4 lg4 mb-3>
            <v-btn color="red lighten-4" @click="$router.go(-1)">Back to Dashboard</v-btn>
        </v-flex>

        <v-flex xs12 md6 offset-md2 lg4 offset-lg4 px-1>
            <v-select :items="semesters" item-text="name" item-disabled="false" placeholder="Choose Semester" single-line box autofocus return-object v-model="chosenSemester" background-color="yellow" prepend-inner-icon="alarm">
            </v-select>
        </v-flex>

    </v-layout>

    <v-layout column wrap>

        <v-flex xs12>
            <student-schedule :semester="chosenSemester"></student-schedule>
        </v-flex>

        <v-flex my-5>
            <p class="headline" v-html="semesterNotes.message"></p>
            <v-divider></v-divider>
        </v-flex>

        <div v-if="chosenSemester.name !== undefined">
            <courses-dropdown day="M" color="yellow" :semester="chosenSemester" :grade="student.grade"></courses-dropdown>
            <courses-dropdown day="T/TH" color="green" :semester="chosenSemester" :grade="student.grade"></courses-dropdown>
            <courses-dropdown day="W" color="blue" :semester="chosenSemester" :grade="student.grade"></courses-dropdown>
            <courses-dropdown day="F" color="pink" :semester="chosenSemester" :grade="student.grade"></courses-dropdown>
        </div>

        <v-dialog persistent v-model="classStatusAlert" max-width="500px">
            <v-card>
                <v-card-text>
                    <v-progress-linear v-if="progress" indeterminate :size="100" :width="10" style="text-align: center;" color="primary" background-color="warning">
                    </v-progress-linear>
                    <div v-else>
                        <!-- make text bold and bigger, easier to read -->
                        <v-alert :value="httpResponse.code === 201" type="success" v-text="httpResponse.message"></v-alert>
                        <v-alert :value="httpResponse.code === 202" type="warning" class="black--text" v-text="httpResponse.message"></v-alert>
                        <v-alert :value="httpResponse.code === 422" type="error" v-text="httpResponse.message"></v-alert>
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-btn v-if="!progress" color="primary" flat @click.stop="closeAlert">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="enrollConfirmDialog" persistent max-width="500px">
            <v-card>
                <v-card-title>
                    <h5 class="headline">Are you sure you want to add this class?</h5>
                </v-card-title>
                <v-card-text>
                    <h6 class="title primary--text">{{ selectedCourse.section }} | {{ selectedCourse.name }}</h6>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red lighten-4" @click.native="enrollConfirmDialog = false">No</v-btn>
                    <v-btn color="green lighten-4" @click.native="attemptEnrollment()">Yes</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="waitListConfirmDialog" persistent max-width="500px">
            <v-card>
                <v-card-title>
                    <h5 class="headline">Are you sure you want to go on the wait list?</h5>
                </v-card-title>
                <v-card-text>
                    <h6 class="title primary--text">{{ selectedCourse.section }} | {{ selectedCourse.name }}</h6>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red lighten-4" @click.native="waitListConfirmDialog = false">No</v-btn>
                    <v-btn color="green lighten-4" @click.native="joinWaitlist()">Yes</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </v-layout>
</v-container>
</template>

<script>
import CoursesDropdown from './coursesDropdown'
import StudentSchedule from './studentSchedule'
import {
    getGradeLevelNotes
} from '@/helpers/functions.js'

export default {
    components: {
        CoursesDropdown,
        StudentSchedule
    },
    data() {
        return {
            chosenSemester: {},
            semesterNotes: {},
            enrollConfirmDialog: false,
            waitListConfirmDialog: false,
            selectedCourse: {},
            classStatusAlert: false,
            progress: false
        }
    },
    created() {
        this.$store.dispatch('getSemesters')
        this.$store.commit('setEnrollmentSchedule', {
            enrolled: [],
            waiting: []
        })
    },
    beforeRouteLeave(to, from, next) {
        this.$store.commit('setEnrollmentSchedule', {
            enrolled: [],
            waiting: []
        })
        next()
    },
    mounted() {
        this.$root.$on('enrollInCourse', (course) => {
            this.selectedCourse = course
            this.enrollConfirmDialog = true
        })
        this.$root.$on('waitlistCourse', (course) => {
            this.selectedCourse = course
            this.waitListConfirmDialog = true
        })
    },
    watch: {
        'chosenSemester'(semester) {
            this.$store.dispatch('getSemesterCourses', semester.id)
            this.$store.dispatch('getStudentSchedule', semester.name)
            this.semesterNotes = getGradeLevelNotes(semester, this.student.grade)
        }
    },
    computed: {
        culprit() {
            return this.$store.getters.culprit
        },
        student() {
            return this.$store.state.enrollment.student
        },
        httpResponse() {
            return this.$store.state.enrollment.httpResponse
        },
        semesters() {
            return this.$store.getters.activeSemesters
        }
    },
    methods: {
        attemptEnrollment() {
            const payload = {
                course_id: this.selectedCourse.id,
                student_id: this.student.id,
                culprit: this.culprit
            }

            this.enrollConfirmDialog = false
            this.classStatusAlert = true
            this.progress = true

            // timer to slow down the user and space out the api calls
            setTimeout(() => {
                this.$store.dispatch('addClass', payload)
                    .then(() => {
                        this.progress = false
                    })
                    .catch(() => {
                        this.progress = false
                    })
            }, 2000)

        },
        joinWaitlist() {
            const payload = {
                course_id: this.selectedCourse.id,
                student_id: this.student.id,
                culprit: this.culprit
            }

            this.waitListConfirmDialog = false
            this.classStatusAlert = true
            this.progress = true

            // timer to slow down the user and space out the api calls
            setTimeout(() => {
                this.$store.dispatch('addWaitlistEntry', payload)
                    .then(() => {
                        this.progress = false
                    })
                    .catch(() => {
                        this.progress = false
                    })
            }, 2000)
        },
        closeAlert() {
            this.classStatusAlert = false
            this.progress = false
            this.$store.commit('clearEnrollmentHttpResponse')
        }
    }
}
</script>
